import { Action } from 'redux-actions'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import api from '../../../services/api.services'
import { GetUserNotifications$Request, MarkUserNotificationRead$Request } from '../../../services/api.types'
import {
  getUserNotifications,
  getUserNotificationsFail,
  getUserNotificationsSuccess,
  markUserNotificationRead,
  markUserNotificationReadFail,
  markUserNotificationReadSuccess,
} from './InboxActions'
import { getWhoAmI } from '../../../common/auth/authActions'
import { clearNotification } from '../../../common/notifications/NotificationActions'

function* sagaGetUserNotifications(action: Action<GetUserNotifications$Request>) {
  //yield put({ type: String(clearNotification) })
  try {
    const { userNotifications } = yield call(api.users.getUserNotifications, action.payload)
    yield put({ type: String(getUserNotificationsSuccess), payload: userNotifications })
  } catch (e: any) {
    console.log('GetUserNotificationsFail: ', e)
    yield put({ type: String(getUserNotificationsFail) })
  }
}

function* sagaMarkUserNotificationRead(action: Action<MarkUserNotificationRead$Request>) {
  yield put({ type: String(clearNotification) })
  try {
    yield call(api.users.markUserNotificationRead, action.payload)
    yield put({ type: String(getUserNotifications), payload: {} })
    yield put({ type: String(getWhoAmI) })
    yield put({ type: String(markUserNotificationReadSuccess) })
  } catch (e: any) {
    console.log('MarkUserNotificationReadFail: ', e)
    yield put({ type: String(markUserNotificationReadFail) })
  }
}

export function* inboxSagas() {
  yield all([takeEvery(String(getUserNotifications), sagaGetUserNotifications)])
  yield all([takeEvery(String(markUserNotificationRead), sagaMarkUserNotificationRead)])
}
